import React, { Component } from 'react';
import {
    CONTRACT_STATE_FEEDBACK,
    CONTRACT_STATE_SENT,
    CONTRACT_STATE_SIGNED,
    CONTRACT_STATE_SENT_DRAFT
} from '../../../constants/settings';
import { msToTime } from '../../../lib/date.utils';
import { UserContext } from '../../../Application';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';
import { sanitizeHtml } from '../../../lib/html.utils';

class ReviewHeader extends Component {
    _instructionsOne = user => {
        if (!this.props.currentIsLast) {
            return (
                <span>
                    This is a previous version of the contract in <span className="u-bold">READ-ONLY</span> mode.
                </span>
            );
        }
        switch (this.props.state) {
            case CONTRACT_STATE_SENT_DRAFT:
            case CONTRACT_STATE_SENT:
                return hasPermissions(user, PERMISSIONS.SIGN_CONTRACTS_INBOX)
                    ? 'Please review and sign this contract.'
                    : 'Please review this contract.';
            case CONTRACT_STATE_FEEDBACK:
                return 'Feedback has been sent for this version.';
            case CONTRACT_STATE_SIGNED:
                return 'This contract has been signed.';
            default:
                return '';
        }
    };
    _instructionsTwo = isUpload => {
        if (isUpload) {
            return '';
        }
        if (!this.props.currentIsLast) {
            return null;
        }
        switch (this.props.state) {
            case CONTRACT_STATE_SENT:
            case CONTRACT_STATE_SENT_DRAFT:
                return "Tap on a section whenever you'd like to add additional comments before signing.";
            case CONTRACT_STATE_FEEDBACK:
                return 'A new contract version will be sent for signing.';
            case CONTRACT_STATE_SIGNED:
                return (
                    <span>
                        Signed by <span className="u-bold">{this.props.userName}</span> on{' '}
                        <span className="u-bold">{msToTime(this.props.signedOn)}</span>
                    </span>
                );
            default:
                return '';
        }
    };
    render() {
        const { comments } = this.props;
        return (
            <UserContext.Consumer>
                {user => (
                    <header className="ckp-contracts-review-header">
                        <div className="ckp-contracts-review-header-text">
                            {this._instructionsOne(user)}
                            {this.props.currentIsLast ? (
                                <React.Fragment>
                                    <br /> {this._instructionsTwo(this.props.isUpload)}
                                    <br />
                                </React.Fragment>
                            ) : null}
                            {this.props.state !== CONTRACT_STATE_SIGNED ? (
                                <React.Fragment>
                                    <br />-
                                </React.Fragment>
                            ) : null}
                            {(comments && comments.admin && this.props.state === CONTRACT_STATE_SENT) ||
                            (this.props.isUpload && comments && comments.admin)
                                ? [
                                      <br key="ckp-contracts-review-br" />,
                                      <div
                                          key="ckp-contracts-review-comment"
                                          dangerouslySetInnerHTML={{
                                              __html: `<br />${(sanitizeHtml(comments.admin) || '').replace(
                                                  /(?:\r\n|\r|\n)/g,
                                                  '<br />'
                                              )}`
                                          }}
                                      />
                                  ]
                                : null}
                        </div>
                    </header>
                )}
            </UserContext.Consumer>
        );
    }
}

export default ReviewHeader;
